export const routes = {
	root: '/',
	login: '/login',
	userModuleLogin: '/userModuleLogin',
	locations: '/locations',
	locationDetails: '/locations/:id',
	deviceDetails: '/devices/:id',
	devices: '/devices',
	users: '/users',
	userDetails: '/users/:id',
	userPasswordReset: '/users/reset-password',
	graphics: '/graphics',
	goals: '/goals',
	rules: '/rules',
	externalLogin: '/externalLogin',
	logout: '/logout',
	notFound: '/not-found',
	deviceComponent: '/device/:deviceId/deviceComponent',
};
